/* Fight Trade FG4 dark featured gear (approved 2026-10-23)
   <ft-featured-tabs> for sections/ft-featured-gear.liquid (loaded deferred by
   that section only). All panels are rendered server-side; this only switches
   them:
   - click / Arrow keys / Home / End select a tab (focus moves = activation),
     roving tabindex, aria-selected, hidden on the panels;
   - Up/Left = previous, Down/Right = next in both layouts; aria-orientation
     follows the layout (vertical from 1024px, horizontal scroller below);
   - the CTA href follows the open tab (data-url) and its aria-label becomes
     "<CTA label>: <tab label>";
   - under 1024px the active tab is kept in view in the scroller;
   - theme editor: shopify:block:select opens the selected tab; a re-rendered
     section (shopify:section:load) upgrades itself as a custom element.
   The tile fade-up is CSS (it restarts when hidden is removed) and is off
   under prefers-reduced-motion. Does nothing when the markup is missing. */
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('ft-featured-tabs')) return;

  var DESKTOP = '(min-width: 1024px)';
  var PREV = { ArrowUp: 1, ArrowLeft: 1, Up: 1, Left: 1 };
  var NEXT = { ArrowDown: 1, ArrowRight: 1, Down: 1, Right: 1 };

  function media(q) {
    return window.matchMedia ? window.matchMedia(q) : null;
  }
  function closestTab(node) {
    return node && node.closest ? node.closest('[role="tab"]') : null;
  }

  class FtFeaturedTabs extends HTMLElement {
    connectedCallback() {
      this.setup();
    }

    disconnectedCallback() {
      if (this.mq && this.onMedia) {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMedia);
        else if (this.mq.removeListener) this.mq.removeListener(this.onMedia);
      }
      this.ready = false;
    }

    setup() {
      if (this.ready) return;
      var list = this.querySelector('[role="tablist"]');
      if (!list) return;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;
      this.ready = true;
      this.list = list;
      this.tabs = tabs;
      this.cta = this.querySelector('[data-ft-fg-cta]');
      this.mq = media(DESKTOP);
      this.onMedia = this.orient.bind(this);
      if (this.mq) {
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMedia);
        else if (this.mq.addListener) this.mq.addListener(this.onMedia);
      }
      this.orient();

      if (!this.bound) {
        this.bound = true;
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKey.bind(this));
        this.addEventListener('shopify:block:select', this.onBlock.bind(this));
        // re-sync aria-orientation when focus enters, in case a media-query
        // change event was missed (background tab, device rotation)
        this.addEventListener('focusin', this.orient.bind(this));
      }

      var current = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      this.select(current, false, true);
    }

    isDesktop() {
      return !this.mq || this.mq.matches;
    }

    orient() {
      if (this.list) this.list.setAttribute('aria-orientation', this.isDesktop() ? 'vertical' : 'horizontal');
    }

    owns(tab) {
      return !!tab && !!this.tabs && this.tabs.indexOf(tab) > -1;
    }

    onClick(e) {
      var tab = closestTab(e.target);
      if (this.owns(tab)) this.select(tab, false, false);
    }

    onKey(e) {
      var tab = closestTab(e.target);
      if (!this.owns(tab) || e.altKey || e.ctrlKey || e.metaKey) return;
      var i = this.tabs.indexOf(tab);
      var n = this.tabs.length;
      var j;
      if (PREV[e.key]) j = (i - 1 + n) % n;
      else if (NEXT[e.key]) j = (i + 1) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      else return;
      e.preventDefault();
      this.select(this.tabs[j], true, false);
    }

    onBlock(e) {
      var tab = closestTab(e.target);
      if (this.owns(tab)) this.select(tab, false, false);
    }

    select(tab, focus, quiet) {
      if (!this.owns(tab)) return;
      this.tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var id = t.getAttribute('aria-controls');
        var panel = id ? document.getElementById(id) : null;
        if (panel) panel.hidden = !on;
      });

      if (this.cta) {
        var url = tab.getAttribute('data-url');
        if (url) this.cta.setAttribute('href', url);
        var base = this.cta.getAttribute('data-label') || this.cta.textContent.trim();
        var label = tab.getAttribute('data-label');
        this.cta.setAttribute('aria-label', label ? base + ': ' + label : base);
      }

      if (focus) {
        if (this.isDesktop()) tab.focus();
        else {
          try { tab.focus({ preventScroll: true }); } catch (err) { tab.focus(); }
        }
      }
      // instant (no smooth animation): keyboard moves land at once and nothing
      // moves under prefers-reduced-motion
      if (!quiet && !this.isDesktop() && tab.scrollIntoView) {
        try {
          tab.scrollIntoView({ inline: 'nearest', block: 'nearest' });
        } catch (err) { /* old browsers: the scroller still scrolls by hand */ }
      }
    }
  }

  window.customElements.define('ft-featured-tabs', FtFeaturedTabs);

  // Theme editor: a re-rendered section is upgraded by connectedCallback; this
  // also covers an element that was in the DOM before its markup was complete.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll('ft-featured-tabs'), function (el) {
      if (typeof el.setup === 'function') el.setup();
    });
  });
})();
